
import Vue from 'vue'
import { minLength, required } from 'vuelidate/lib/validators'
import { email } from 'vuelidate-cyrillic-email-validator'
import { userGetInfo } from '@/connectors/user'
import { IManagingOrganization } from '@/types/user'
import showManOrg from '@/connectors/managing-organization/show-managing-organization'
import updateManOrg from '@/connectors/managing-organization/update-managing-organization'
import Loader from '@/components/Loader.vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: 'ManOrganizationFormWizard',
  components: { Loader },
  data () {
    return {
      loader: false,
      managingOrganization: {
        shortName: '',
        phone: '',
        email: '',
        inn: '',
        onlyOneHouse: 0
      } as IManagingOrganization,
      dirtyPhone: ''
    }
  },
  async mounted () {
    await this.setDefaultInfo();
    this.showManagingOrganization()
  },
  methods: {
    ...mapActions('profile', [
      'setDefaultInfo',
    ]),
    showManagingOrganization () {
      this.loader = true
      showManOrg(Number(localStorage.getItem('moid')), 0, 1)
        .then(response => {
          console.log('managingTSG', response)

          if (response.houses?.length <= 1) {
            this.managingOrganization.onlyOneHouse = 0
          } else this.managingOrganization.onlyOneHouse = 1
          if (response.phone && response.phone[0] === '7') {
            this.dirtyPhone = '+7' + response.phone
          } else this.dirtyPhone = response.phone || ''
          this.managingOrganization = response
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e)
          // @ts-ignore
          this.$showErrorToast(e.message)
        })
    },
    createMO () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      this.managingOrganization.systemSite = undefined

      this.managingOrganization.phone = this.dirtyPhone.replaceAll(' ', '')

      if (localStorage.getItem('moid')) {
        updateManOrg(Number(localStorage.getItem('moid')), this.managingOrganization)
          .then((res) => {
            userGetInfo().then((response) => {
              console.log('user', response)
              this.$store.dispatch('profile/setUser', response.user)
              this.$store.dispatch('profile/selectOrganization', 0)
            }).then(() => (this.$router.push('/app/checking_account_form_wizard')))
            console.log('mo', res)
            this.$store.dispatch('profile/addOrganization', res)
          }).catch((e) => {
            console.error(e.response, 'err')
            if (e.response.status === 403) {
            // @ts-ignore
              this.$showErrorToast(e.response.data.message)
            } else {
              console.error(e.response)
              // @ts-ignore
              this.$showErrorToast(e.response.data.message)
            }
          })
      }
    }
  },
  validations: {
    managingOrganization: {
      shortName: {
        required
      },
      phone: {
      },
      email: {
        email
      },
      inn: {
        required,
        validation (val: string) {
          return /^(\d{10}|\d{12})$/.test(val)
        }
      }
    },
    dirtyPhone: {
      required,
      minLength: minLength(16)
    }
  }
})
